var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "uni-error-modal",
      attrs: { title: "提示", visible: _vm.isVisible, width: "50%" },
      on: {
        "update:visible": function ($event) {
          _vm.isVisible = $event
        },
        closed: _vm.updateVisible,
      },
    },
    [
      _c("div", { staticClass: "title" }, [
        _c("img", {
          staticClass: "mar20",
          staticStyle: { width: "60px", height: "62px" },
          attrs: { src: require("@/assets/images/jc.png"), alt: "" },
        }),
        _vm._v(
          " 一直在完善，从未停歇过，但有些题目可能仍然存在瑕疵，对您造成的不便我们深表歉意 "
        ),
      ]),
      _c(
        "el-radio-group",
        {
          staticClass: "err-radio",
          model: {
            value: _vm.errorType,
            callback: function ($$v) {
              _vm.errorType = $$v
            },
            expression: "errorType",
          },
        },
        _vm._l(_vm.errorList, function (item) {
          return _c(
            "el-radio",
            { key: item, staticClass: "radio", attrs: { label: item } },
            [_vm._v(_vm._s(item))]
          )
        }),
        1
      ),
      _c(
        "div",
        { staticClass: "textarea-box" },
        [
          _c("el-input", {
            attrs: {
              type: "textarea",
              rows: "5",
              placeholder: "请输入纠正内容（200字以内）",
              maxlength: "200",
              "show-word-limit": "",
            },
            model: {
              value: _vm.content,
              callback: function ($$v) {
                _vm.content = $$v
              },
              expression: "content",
            },
          }),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticClass: "refer-btn",
              attrs: { type: "primary" },
              on: { click: _vm.saveTopicError },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }